import React from 'react';
import { ChevronDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { mockData } from '../mock';

const Hero = () => {
  const { hero } = mockData;
  const navigate = useNavigate();

  // Função exclusiva para scroll interno da Home
  const handleScroll = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Função exclusiva para navegar para outra página
  const handleNavigation = (path) => {
    window.scrollTo(0, 0); // Garante que a nova página comece no topo
    navigate(path);
  };

  return (
    <section id="inicio" className="relative min-h-screen flex flex-col justify-start md:justify-center overflow-hidden bg-[#05040a]">
      
      {/* IMAGEM DE FUNDO */}
      <div 
        className="absolute inset-0 bg-cover bg-no-repeat bg-bottom md:bg-center transition-all duration-1000 scale-105"
        style={{ 
          backgroundImage: `url('${hero.image}')`,
          zIndex: 1 
        }} 
      />

      {/* OVERLAY */}
      <div 
        className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/20 to-[#05040a]" 
        style={{ zIndex: 2 }}
      />

      <div className="relative z-10 max-w-6xl mx-auto px-4 pt-24 md:pt-32 text-center select-none">
        <div className="mb-6">
          <span className="px-5 py-2 rounded-full text-[10px] tracking-[0.2em] font-bold bg-orange-500/10 text-orange-400 border border-orange-500/30 backdrop-blur-xl uppercase">
            {hero.badge}
          </span>
        </div>

        <h1 className="text-6xl md:text-9xl font-black text-white mb-6 tracking-tighter drop-shadow-2xl">
          UNIFI<span className="gradient-text">CADOS</span>
        </h1>

        <p className="text-lg md:text-2xl text-gray-300 font-light mb-12 max-w-3xl mx-auto drop-shadow-lg px-6 leading-relaxed">
          {hero.subtitle}
        </p>

        <div className="flex flex-col items-center gap-8">
          
          {/* BOTÕES DE SCROLL */}
          <div className="flex flex-col sm:flex-row gap-5 justify-center items-center w-full px-10">
            <button
              onClick={(e) => handleScroll(e, 'inscricao-home')}
              className="w-full sm:w-auto bg-gradient-to-r from-orange-600 to-rose-600 text-white font-extrabold text-lg px-12 py-5 rounded-2xl shadow-[0_0_30px_rgba(249,115,22,0.3)] hover:shadow-[0_0_50px_rgba(249,115,22,0.5)] transition-all active:scale-95"
            >
              {hero.cta}
            </button>

            <button
              onClick={(e) => handleScroll(e, 'sobre')}
              className="w-full sm:w-auto border border-white/20 bg-white/5 text-white hover:bg-white/10 font-bold text-lg px-12 py-5 rounded-2xl backdrop-blur-md transition-all active:scale-95"
            >
              Saiba Mais
            </button>
          </div>

          {/* LINK DE NAVEGAÇÃO PURA - SEM QUALQUER RELAÇÃO COM SCROLL */}
          <div className="text-zinc-500 text-sm font-medium tracking-wide">
            Já é um Unificado? 
            <button 
              type="button"
              onClick={() => window.location.href = 'https://unificadosapp.pages.dev/'} 
              className="text-orange-500 hover:text-orange-400 ml-2 font-black transition-all hover:underline underline-offset-4 cursor-pointer"
            >
              Fazer Login
            </button>
          </div>
        </div>
      </div>

      <div className="hidden md:flex absolute bottom-12 left-1/2 -translate-x-1/2 z-10 flex-col items-center gap-2 opacity-40 hover:opacity-100 transition-opacity cursor-pointer" onClick={(e) => handleScroll(e, 'sobre')}>
        <span className="text-[10px] text-white tracking-[0.3em] uppercase font-bold">Role para ver</span>
        <ChevronDown size={24} className="text-white animate-bounce" />
      </div>

    </section>
  );
};

export default Hero;